export default "__VITE_ASSET__79adae30__"